<template>
  <el-config-provider :locale="ElementZhTw">
    <a-config-provider :locale="AntdZhHk">
      <el-container id="app-container">
        <BuyServiceTips />
        <router-view v-slot="{ Component, route }">
          <transition :name="route.meta.transition || 'fade'" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </el-container>
    </a-config-provider>
  </el-config-provider>
</template>

<script setup>
import ElementZhTw from 'element-plus/dist/locale/zh-tw.mjs';
import { useGlobalSocket } from '@/hooks/webSocket';
import { useRollupNotifyTitle } from '@/hooks/useRollupTitle';
import AntdZhHk from 'ant-design-vue/es/locale/zh_HK';
import useFaviconCount from '@/hooks/useFaviconCount';
import useChatListStore from '@/store/chatList';
import { useRoute } from 'vue-router';
import pinia from '@/store';
import { useSaleOnlineStatus } from '@/hooks/useSaleOnlineStatus';
import BuyServiceTips from '@/components/BuyServiceTips/index.vue';

useGlobalSocket(); // 全局範圍的socket
useRollupNotifyTitle(); // 滾動標題
useSaleOnlineStatus(); // 銷售在線狀態（閒置自動離線）
// useFaviconCount(); // 帶數字的Favicon

// 這裏存儲路由信息，用於判斷接口那邊根據路由判斷使用哪個接口
const chatListStore = useChatListStore(pinia);
chatListStore.route = useRoute();

if (localStorage.getItem('isIE') !== 'false') {
  localStorage.setItem('isIE', 'false');
  const element = document.getElementById('IETip');
  if (element) {
    document.body.removeChild(element);
  }
}
</script>

<style lang="scss">
/* 重置瀏覽器樣式 */
@import '~@/assets/style/reset.scss';

#app-container {
  width: 100vw;
  min-height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

*::selection {
  background: rgb(51, 141, 233);
  color: #ffffff;
}
</style>
